const renderFiverr = () => {
  const zones = document.querySelectorAll("[data-zone-fiverr]")
  if (zones.length == 0) return

  const language = document.documentElement.lang

  zones.forEach(zone => {
    const code = zone.dataset.zoneFiverr
    zone.insertAdjacentHTML(
      "beforeend",
      `<iframe src="https://tools.fiverr.com/?searchbox-iframe=1&amp;affid=${code}&amp;widget-commission=fiverrhybrid&amp;widget-style=1&amp;widget-width=800&amp;delivery-time-flag=show-delivery-time&amp;widget-search-placeholder=3D+Model+for+3D+printing&amp;widget-language=${language}" border="0" scrolling="no" height="320px" width="100%" class="fasb-iframe-searchbox-widget" data-origwidth="100%" data-origheight="253px" widget-style="1" max-width="800" widget-width="800" delivery-time-flag="show-delivery-time" widget-language="${language}"></iframe>`
    )
  })
}

export { renderFiverr }
